import { EngagementBlueprintActivitiesParams } from "PFCore/services/engagement_blueprints";
import { Id } from "PFTypes";

export const engagementBlueprintsKeys = {
  all: () => ["engagementBlueprints"],
  single: (id: Id) => [...engagementBlueprintsKeys.all(), "single", id],
  activities: (id: Id, params: EngagementBlueprintActivitiesParams) => [
    ...engagementBlueprintsKeys.single(id),
    "activities",
    params
  ]
};
